import { z } from "zod";

/** Department-scoped access grants, separate from a member's global Portal rank. */
export const DEPARTMENT_PERMISSIONS = [
  "manage_department",
  "manage_subdivisions",
  "manage_roster",
  "assign_ranks",
  "manage_permissions",
  "approve_transfers",
  "department_admin",
  "manage_training",
  "manage_certifications",
  "grade_training",
  "schedule_training",
  "manage_department_content",
  "manage_announcements",
] as const;
export const DepartmentPermissionSchema = z.enum(DEPARTMENT_PERMISSIONS);
export type DepartmentPermission = z.infer<typeof DepartmentPermissionSchema>;
